// extracted by mini-css-extract-plugin
module.exports = {"fontPickerContainer":"FontPicker_fontPickerContainer__1-V3m","fontItem":"FontPicker_fontItem__1PVey","title":"FontPicker_title__2NMmF"};